const configEn = {
  page: "Abschnitt-",
  question: "Frage-",
  columns: "Spalten-",
  rows: "Zeilen-",
  choices: "Option-",
  copy: "(Copy)"
};
export default configEn;
